
import {
  computed, defineComponent, reactive,
} from 'vue';
import { IOrdemProducaoControle, IOrdemProducaoEtapa } from '@/models/Entidades/PCP/IOrdemProducao';
import { ETipoControleProducao } from '@/models/Enumeradores/Cadastros/PCP/ETipoControleProcucao';
import MateriaPrimaEtapaOrdemProducao from './MateriaPrimaEtapaOrdemProducao.vue';
import ProdutoAcabadoEtapaOrdemProducao from './ProdutoAcabadoEtapaOrdemProducao.vue';

import OrdemProducaoControle from './OrdemProducaoControle.vue';

export default defineComponent({
  name: 'OrdemProducaoEtapas',
  props: {
    etapas: {
      type: Array as () => IOrdemProducaoEtapa[],
      required: true,
    },
    tipo: {
      type: Number,
      required: true,
    },
    controles: {
      type: Array as () => IOrdemProducaoControle[],
      required: true,
    },
    empresas: {
      type: Array as () => number[],
      required: true,
    },
    codigoOrdemProducao: {
      type: Number,
      required: true,
    },
    editavel: {
      type: Boolean,
      default: false,
    },
    produtoAcabadoEditavel: {
      type: Boolean,
      default: false,
    },
    editarApontamentoMateriaPrima: {
      type: Boolean,
      default: false,
    },
    criarApontamentoProdutoAcabado: {
      type: Boolean,
      required: true,
    },
    statusOrdemProducao: {
      type: Number,
      required: true,
    },
    abaEtapaAtiva: {
      type: String,
      default: '1',
    },
    atualizarControles: {
      type: Boolean,
      default: false,
    },
    codigoProdutoOrdemProducao: {
      type: Number,
      default: 0,
    },
    casasDecimaisCusto: {
      type: Number,
      default: 2,
    },
  },
  components: {
    MateriaPrimaEtapaOrdemProducao,
    ProdutoAcabadoEtapaOrdemProducao,
    OrdemProducaoControle,
  },
  emits: ['update:etapas', 'update:ordemProducao', 'update:contorles', 'update:criarApontamentoProdutoAcabado', 'update:editarApontamentoMateriaPrima', 'update:abaEtapaAtiva', 'update:atualizarControles'],
  setup(props, { emit }) {
    const state = reactive({
      indexSelecionado: 0,
      etapaSelecionada: 0,
      abaEtapaAtiva: '0',
    });
    const computedEtapas = computed({
      get: () => props.etapas,
      set: (etapas: IOrdemProducaoEtapa[]) => {
        emit('update:etapas', etapas);
      },
    });
    const computedControles = computed({
      get: () => props.controles,
      set: (controles: IOrdemProducaoControle[]) => {
        emit('update:contorles', controles);
      },
    });
    const computedAbaEtapaAtiva = computed({
      get: () => props.abaEtapaAtiva,
      set: (index: string) => {
        emit('update:abaEtapaAtiva', index);
      },
    });
    const computedAtualizarControles = computed({
      get: () => props.atualizarControles,
      set: (val: boolean) => {
        emit('update:atualizarControles', val);
      },
    });
    const computedCriarApontamentoProdutoAcabado = computed({
      get: () => props.criarApontamentoProdutoAcabado,
      set: (valor: boolean) => {
        emit('update:criarApontamentoProdutoAcabado', valor);
      },
    });
    const computedEditarApontamentoMateriaPrima = computed({
      get: () => props.editarApontamentoMateriaPrima,
      set: (valor: boolean) => {
        emit('update:editarApontamentoMateriaPrima', valor);
      },
    });

    const computedDensidade = computed(() => {
      if (computedControles.value) {
        const controleDensidade = computedControles.value.find((c) => c.tipoControle === ETipoControleProducao.Densidade);
        return controleDensidade ? controleDensidade.valor || 0 : 0;
      }
      return 0;
    });

    return {
      props,
      state,
      computedEtapas,
      computedControles,
      computedCriarApontamentoProdutoAcabado,
      computedEditarApontamentoMateriaPrima,
      computedAbaEtapaAtiva,
      computedAtualizarControles,
      computedDensidade,
    };
  },
});
